const Cartdetails = [
  {
    id: 1,
    slug: "watch-ecommerce-site",
    projectName: "Watch Ecommerce Site",
    ProjectType: "Web Application",
    image: "/preview.png",
    description:
      "An e-commerce storefront concept focused on product browsing, cart interaction, and checkout-oriented user flows.",
    role: "Frontend and UI implementation",
    technologies: ["React", "JavaScript", "Tailwind CSS"],
    features: ["Product discovery", "Cart-focused flow", "Responsive storefront layout"],
    outcome: "Delivered a smoother purchase flow with cleaner product discovery and checkout.",
    githubUrl: "https://github.com/rojash03",
    liveUrl: "https://github.com/rojash03",
  },
  {
    id: 2,
    slug: "library-management-system",
    projectName: "Library Management System",
    ProjectType: "Web and Mobile Application",
    image: "/preview.png",
    description:
      "A cross-platform management system for organizing books, users, borrowing records, and due-date tracking.",
    role: "Application design and development",
    technologies: ["React", "JavaScript", "Node.js"],
    features: ["Book record management", "Borrowing workflow", "Due-date monitoring"],
    outcome: "Improved tracking of borrowed books and made due-date monitoring more reliable.",
    githubUrl: "https://github.com/rojash03",
    liveUrl: "https://librarynesthub.vercel.app/",
  },
  {
    id: 3,
    slug: "baadfaad",
    projectName: "BaadFaad",
    ProjectType: "Web Application with PWA features",
    image: "/baadfaad.png",
    description:
      "A progressive web app designed around fast loading, installability, and offline-ready access for mobile users.",
    role: "Frontend and PWA development",
    technologies: ["React", "JavaScript", "PWA"],
    features: ["Installable experience", "Offline-ready access", "Mobile-focused interface"],
    outcome: "Improved mobile usability through installable and offline-capable experience.",
    githubUrl: "https://github.com/rojash03",
    liveUrl: "https://baadfaad.vercel.app/",
  },
  {
    id: 4,
    slug: "footstats",
    projectName: "FootStats",
    ProjectType: "Web Application",
    image: "/Footstats.png",
    description:
      "A football statistics dashboard that presents trends, teams, and match performance insights in a clearer interface.",
    role: "Dashboard UI and frontend development",
    technologies: ["React", "JavaScript", "Tailwind CSS"],
    features: ["Football statistics views", "Team and match insights", "Dashboard-style layout"],
    outcome: "Converted raw match data into clearer visual insights for faster analysis.",
    githubUrl: "https://github.com/rojash03",
    liveUrl: "https://footstatsnp.vercel.app/",
  },
  {
    id: 5,
    slug: "shikshasathi",
    projectName: "ShikshaSathi",
    ProjectType: "Web Application",
    image: "/preview.png",
    description:
      "An educational platform concept for students and teachers to collaborate and share classroom resources.",
    role: "Web application design and development",
    technologies: ["React", "JavaScript"],
    features: ["Resource sharing", "Student-teacher collaboration", "Education-focused interface"],
    outcome: "Created a single collaboration space for classroom resource sharing.",
    githubUrl: "https://github.com/rojash03",
    liveUrl: "https://github.com/rojash03",
  },
  {
    id: 6,
    slug: "sahayogi-connect",
    projectName: "Sahayogi Connect",
    ProjectType: "Web Application",
    image: "/preview.png",
    description:
      "A community platform concept for connecting volunteers with local organizations, social causes, and support opportunities.",
    role: "Frontend application development",
    technologies: ["React", "JavaScript"],
    features: ["Volunteer discovery", "Cause matching", "Community organization listings"],
    outcome: "Made volunteer discovery and cause matching faster and easier.",
    githubUrl: "https://github.com/rojash03",
    liveUrl: "https://sahayogiconnect.vercel.app",
  },
];

const timeline = [
  {
    id: 1,
    year: "2022",
    event: "Started higher secondary education at Shikshadeep College.",
  },
  {
    id: 2,
    year: "2024",
    event: "Completed higher secondary education with a focus on Computer Science.",
  },
  {
    id: 3,
    year: "2024",
    event:
      "Enrolled in the B.Sc. (Hons) Computing program at Itahari International College.",
  },
  {
    id: 4,
    year: "2025",
    event: "Completed the second year of the B.Sc. (Hons) Computing program.",
  },
];

const interests = [
  {
    id: 1,
    interest: "Cybersecurity",
    description: "Passionate about protecting digital infrastructure.",
  },
  {
    id: 2,
    interest: "Web Development",
    description: "Enjoy building interactive and user-friendly web applications.",
  },
  {
    id: 3,
    interest: "Full Stack Development",
    description: "Enjoy working on both the front end and back end.",
  },
  {
    id: 4,
    interest: "Problem Solving",
    description: "Love tackling complex problems and finding efficient solutions.",
  },
  {
    id: 5,
    interest: "Learning New Technologies",
    description: "Always eager to explore and learn about new technologies.",
  },
];

const Hobbies = [
  {
    id: 1,
    hobby: "Reading",
    icon: "Reading",
  },
  {
    id: 2,
    hobby: "Gaming",
    icon: "Gaming",
  },
  {
    id: 3,
    hobby: "Traveling",
    icon: "Traveling",
  },
  {
    id: 4,
    hobby: "Music",
    icon: "Music",
  },
];

const skillCategories = [
  {
    title: "Programming Languages",
    skills: ["Java", "Python", "JavaScript", "SQL"],
    color: "blue",
  },
  {
    title: "Web Technologies",
    skills: ["React", "Node.js", "HTML5", "CSS3", "Tailwind CSS", "Express.js"],
    color: "green",
  },
  {
    title: "UI/UX & Frontend Practice",
    skills: ["Responsive Design", "Accessible Layouts", "User-Friendly Interfaces", "Performance-Focused UI"],
    color: "purple",
  },
  {
    title: "Databases",
    skills: ["MySQL", "MongoDB", "PostgreSQL"],
    color: "orange",
  },
  {
    title: "Tools & Technologies",
    skills: ["Git", "GitHub", "Postman"],
    color: "purple",
  },
];

export { Cartdetails, timeline, interests, Hobbies, skillCategories };
